import styled, { css } from 'styled-components';

import { colors } from 'global/colors';
import { courseExerciseStatus } from 'constants/tests';

export const HeadingLabel = styled.label`
  color: ${({ theme }) => theme.communityList.selectedColor};
  font-weight: 500;
  font-size: 1.5rem;
  text-align: center;
  margin: auto;
  margin-bottom: 10px;
`;

export const ExerciseContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: start;
  position: relative;
  color: ${({ theme }) => theme.communityList.selectedColor};
`;

export const SyllabusContainer = styled.div`
  padding: 15px 0;
`;

export const Link = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  color: ${({ theme }) => theme.communityList.selectedColor};

  :hover {
    color: ${colors.fsCyan};
  }
`;

export const LevelNameContainer = styled.div`
  display: contents;
  @media (max-width: 767px) {
    display: block;
  }
`;

export const LevelName = styled.div`
  cursor: pointer;
  border: 1px solid;
  border-radius: 5px;
  padding: 1px 10px 1px 10px;
  margin-left: 10px;
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 13px;
  width: fit-content;
  color: ${({ theme }) => theme.communityList.selectedColor};
  border-color: ${({ theme }) => theme.communityList.selectedColor};

  ${({ isCompleted }) =>
    isCompleted &&
    css`
      color: ${colors.fsCyan};
      border-color: ${colors.fsCyan};
    `};

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      color: ${colors.white};
      background-color: ${colors.fsCyan};
      border-color: ${colors.fsCyan};
    `};

  @media (max-width: 767px) {
    margin-left: 0px;
    margin-bottom: 5px;
  }
`;

export const CompletedIcon = styled.div``;

export const ExerciseAndLevelNameContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    display: block;
  }
`;

export const ExerciseName = styled.div`
  padding-top: 1px;
`;

export const CurrencyFlag = styled.img`
  width: 18px;
  margin-left: 5px;
`;

export const CourseModalHeading = styled.label`
  color: ${({ theme }) => theme.freecode.modal.color};
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0.7px;
  margin-bottom: 12px;

  ${({ isPurchaseModal }) =>
    isPurchaseModal &&
    css`
      color: ${colors.white};
    `};
`;

export const List = styled.div`
  display: grid;
  margin-bottom: 12px;
`;

export const ListItem = styled.span`
  color: ${({ theme }) => theme.freecode.modal.color};
  text-align: left;
  margin-bottom: 10px;
  font-size: 15px;

  ${({ isPurchaseModal }) =>
    isPurchaseModal &&
    css`
      color: ${colors.white};
    `};
`;

export const CheckIcon = styled.i`
  color: ${({ theme }) => theme.freecode.modal.primaryButtonBackgroundColor};
  margin-right: 10px;

  ${({ isPurchaseModal }) =>
    isPurchaseModal &&
    css`
      color: ${colors.white};
    `};
`;

export const DiamondImage = styled.img`
  width: 50px;
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
`;

export const DiscountPrice = styled.h1`
  color: ${colors.white};
`;

export const ActualPrice = styled.h5`
  color: #cfddf1;
  text-decoration: line-through;
`;

export const PriceContainer = styled.div`
  line-height: 0;
  margin-bottom: 15px;
`;

export const AwaitLine = styled.p`
  font-size: 14px;
  color: #cfddf1;
`;

export const SyllabusName = styled.div`
  color: ${({ theme }) => theme.text};
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;

  ${({ isCurrent }) =>
    isCurrent &&
    css`
      padding: 5px 0;
      border-radius: 10px;
      background: ${({ theme }) => theme.communityList.highlightedItem};
      color: ${({ theme }) => theme.communityList.highlightedItemColor};
    `};
`;

export const ModuleName = styled.div`
  color: ${({ theme }) => theme.text};
  font-size: 15px;
  padding-top: 5px;
  cursor: pointer;

  ${({ isCurrent }) =>
    isCurrent &&
    css`
      color: ${({ theme }) => theme.communityList.highlightedItemColor};
    `};
`;

export const IconContainer = styled.span`
  width: 45px;
  display: inline-block;
  text-align: center;

  ${({ status }) =>
    status === courseExerciseStatus.COMPLETED
      ? css`
          color: ${colors.green4};
        `
      : status === courseExerciseStatus.CURRENT
        ? css`
            color: ${colors.lightBlue16};
          `
        : css`
            color: ${({ theme }) => theme.text};
          `}
`;

export const NameAndModuleContainer = styled.div`
  padding: 12px 0;
`;

export const NameAndDescriptionsContainer = styled.div`
  padding: 10px 20px 20px 40px;
`;

export const FlowModuleName = styled.div`
  color: ${({ theme }) => theme.communityList.highlightedItemColor};
  font-size: 18px;
  font-weight: 500;
`;

export const FlowModuleDescription = styled.div`
  color: ${({ theme }) => theme.communityList.infoColor};
  font-size: 15px;
`;

export const FlowContainer = styled.div`
  display: block;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.communityList.highlightedItem};
  margin-bottom: 15px;
  background: ${({ theme }) => theme.communityList.highlightedItem};
  border-radius: 16px;
  position: relative;
`;

export const EmptyDiv = styled.div``;

export const PracticeButton = styled.button`
  border: 1px solid ${colors.lightBlue16};
  background: ${colors.lightBlue16};
  color: white;
  border-radius: 6px;
  padding: 2px 16px;
  font-weight: 500;
  letter-spacing: 1px;

  &:hover {
    background: ${({ theme }) => theme.primaryButton.backgroundHover};
    color: ${({ theme }) => theme.primaryButton.labelHover};
    border: 1px solid ${({ theme }) => theme.primaryButton.backgroundHover};
  }
`;

export const FlowHeadingContainer = styled.div`
  background: ${({ theme }) => theme.communityList.subHighlightedItem};
  margin: 7px;
  padding: 7px;
  padding-left: 15px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const IconAndNameContainer = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  text-align: center;
  max-width: 110px;
  position: relative;
  cursor: pointer;
  height: 120px;

  :hover {
    transform: scale(1.03);
    animation-fill-mode: forwards;
    z-index: 1;
  }

  ${({ isOddDiv }) =>
    isOddDiv &&
    css`
      align-self: flex-end;
    `}

  ${({ isLocked }) =>
    isLocked &&
    css`
      cursor: default;
    `}

  ${({ top }) =>
    top &&
    css`
      top: ${top}px;
    `}
`;

export const LevelsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  justify-items: center;
  padding: 20px 0;

  ${({ isMobile }) =>
    isMobile &&
    css`
      grid-template-columns: 1fr 1fr 1fr;
    `};

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `};
`;

export const LevelColumn = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const IconImage = styled.img`
  width: 100px;
  position: absolute;
  bottom: 0;
  width: ${(props) => (props.width ? props.width : '100px')};
`;

export const FlowLevelName = styled.span`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  width: 112px;
  word-wrap: break-word;
  hyphens: auto;
  position: relative;
  z-index: 2;
  line-height: 18px;
  display: inline-block;
  white-space: normal;
  color: ${({ theme }) => theme.communityList.infoColor};

  ${({ isLevelUnlocked }) =>
    isLevelUnlocked &&
    css`
      color: ${({ theme }) => theme.communityList.selectedColor};
    `}
`;

export const InvisibleItem = styled.div`
  display: flex;
  align-self: flex-end;
  justify-content: center;
  height: 150px;
  width: 110px;
  cursor: default;
`;

export const CertificateSVG = styled.img`
  height: ${(props) => (props.isMobile ? '50px' : '70px')};
  margin-bottom: 7px;
`;

export const Bubble = styled.div`
  position: absolute;
  bottom: ${({ bottom }) => bottom}px;
  left: ${({ left }) => left}px;
  right: ${({ right }) => right}px;
  width: 115px;
  text-align: center;
  background-color: ${({ theme }) => theme.communityList.highlightedItem};
  border: 1px solid ${({ theme }) => theme.communityList.infoColor};
  border-radius: 6px;
  padding: ${({ isMobile }) => (isMobile ? '5px' : '10px 5px')};
  color: ${({ theme }) => theme.communityList.infoColor};
  font-style: italic;
  z-index: 1;
  font-size: 12px;
  word-wrap: break-word;
  hyphens: auto;
`;

export const SpeechBubbleBefore = styled.div`
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 11px solid;
  border-color: ${({ theme }) => theme.communityList.infoColor} transparent transparent
    ${({ theme }) => theme.communityList.infoColor};
  left: 65px;
  bottom: -22px;

  ${({ isRight }) =>
    isRight &&
    css`
      left: 36px;
      border-color: ${({ theme }) => theme.communityList.infoColor} ${({ theme }) => theme.communityList.infoColor}
        transparent transparent;
    `}
`;

export const SpeechBubbleAfter = styled.div`
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  left: 66px;
  bottom: -20px;
  border: 10px solid;
  border-color: ${({ theme }) => theme.communityList.highlightedItem} transparent transparent
    ${({ theme }) => theme.communityList.highlightedItem};

  ${({ isRight }) =>
    isRight &&
    css`
      left: 37px;
      border-color: ${({ theme }) => theme.communityList.highlightedItem}
        ${({ theme }) => theme.communityList.highlightedItem} transparent transparent;
    `}
`;
